/**
 * Строка-последствие (П6, §5.8, §12.3).
 *
 * Главный приём системы вместо модальных подтверждений: под контролом стоит
 * серая строка, которая объясняет, что случится. Модалка остаётся только для
 * необратимого (§2.3).
 *
 * Два применения:
 *  • `tone="neutral"` — обычное последствие правки («Бренд исчезнет со страниц
 *    сайта после публикации»);
 *  • `tone="danger"` — подпись у необратимого действия в модалке.
 *
 * Если строка объясняет, почему контрол недоступен, её идентификатор нужно
 * передать контролу в `aria-describedby` — иначе причина существует только для
 * зрячих (§2.3: «рядом всегда текст-причина», тултипа мало).
 */
import type { ReactNode } from 'react'
import './ConsequenceLine.css'

export interface ConsequenceLineProps {
  children: ReactNode
  tone?: 'neutral' | 'danger'
  icon?: ReactNode
  id?: string
  className?: string
}

export function ConsequenceLine({
  children,
  tone = 'neutral',
  icon,
  id,
  className,
}: ConsequenceLineProps) {
  const classes = ['consequence', 't-meta']
  if (tone === 'danger') classes.push('consequence--danger')
  if (className) classes.push(className)

  return (
    <p id={id} className={classes.join(' ')}>
      {icon ? <span className="consequence__icon">{icon}</span> : null}
      <span>{children}</span>
    </p>
  )
}
